import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';
import OurModal from '@/components/Modal';

interface Props {
  open: boolean;
  targetUrl: string;
  onCancel: () => void;
  onContinue: () => void;
}

const LeaveWebsiteComponent: React.FC<Props> = ({ open, targetUrl, onCancel, onContinue }) => {
  const { t } = useTranslation('common');

  const handleCancel = () => {
    onCancel();
  };

  const handleContinue = () => {
    onContinue();
  };

  return (
    <OurModal
      isModalOpen={open}
      handleCancel={handleCancel}
      width={440}
      isCenter
      closeIcon={false}
      isNoAddAccount={false}
      title={null}
      closable={false}
      zIndex={1031}
    >
      <div className={styles.leaveModal}>
        {/* 关闭按钮 */}
        <button className={styles.closeBtn} onClick={handleCancel}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M13 1L1 13" stroke="#02183A" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>

        {/* 链接图标 */}
        <div className={styles.iconWrapper}>
          <div className={styles.iconBg}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.1873 11.1102L23.8996 14.8226C24.502 15.4169 24.9809 16.1246 25.3087 16.9048C25.6365 17.685 25.8067 18.5224 25.8095 19.3686C25.8123 20.2149 25.6477 21.0534 25.3252 21.8358C25.0027 22.6181 24.5285 23.329 23.9301 23.9274C23.3317 24.5258 22.6209 24.9999 21.8385 25.3225C21.0561 25.645 20.2176 25.8096 19.3714 25.8068C18.5251 25.8039 17.6878 25.6337 16.9076 25.3059C16.1274 24.9782 15.4197 24.4993 14.8253 23.8969L13.5886 22.6602C13.4214 22.4989 13.288 22.3058 13.1962 22.0924C13.1044 21.8789 13.056 21.6493 13.0539 21.4169C13.0517 21.1846 13.0959 20.9541 13.1838 20.739C13.2717 20.5239 13.4015 20.3285 13.5658 20.1641C13.73 19.9997 13.9253 19.8696 14.1404 19.7815C14.3554 19.6935 14.5858 19.6491 14.8182 19.651C15.0505 19.6529 15.2802 19.701 15.4937 19.7927C15.7073 19.8843 15.9005 20.0175 16.062 20.1846L17.301 21.4224C17.8489 21.9653 18.5895 22.2692 19.3608 22.2674C20.1322 22.2656 20.8714 21.9583 21.4167 21.4128C21.9621 20.8673 22.2691 20.128 22.2707 19.3567C22.2723 18.5853 21.9682 17.8448 21.4251 17.2971L17.7128 13.5847C17.3116 13.1833 16.8019 12.9077 16.2463 12.7916C15.6907 12.6756 15.1134 12.7242 14.585 12.9314C14.3968 13.0061 14.2202 13.0823 14.0553 13.1601L13.514 13.4132C12.7906 13.7399 12.2341 13.8799 11.526 13.1729C10.5086 12.1556 10.7723 11.2164 12.0125 10.3612C13.2479 9.51115 14.742 9.12061 16.2353 9.25744C17.7287 9.39426 19.127 10.0498 20.1873 11.1102ZM13.1756 4.09857L14.4123 5.33523C14.7312 5.66514 14.9078 6.10711 14.9041 6.56596C14.9003 7.0248 14.7165 7.46382 14.3922 7.78843C14.0678 8.11305 13.629 8.29731 13.1702 8.30151C12.7113 8.30571 12.2692 8.12953 11.939 7.8109L10.7011 6.57423C10.4322 6.29559 10.1104 6.0733 9.75459 5.92034C9.39879 5.76738 9.01608 5.68681 8.62881 5.68334C8.24154 5.67986 7.85746 5.75355 7.49897 5.9001C7.14048 6.04665 6.81477 6.26313 6.54084 6.53691C6.26691 6.81069 6.05024 7.13628 5.90349 7.49468C5.75673 7.85309 5.68283 8.23713 5.68608 8.6244C5.68934 9.01168 5.76969 9.39442 5.92245 9.75031C6.07521 10.1062 6.29731 10.4281 6.57581 10.6972L10.2881 14.4096C10.6894 14.811 11.199 15.0866 11.7546 15.2027C12.3102 15.3187 12.8876 15.2701 13.416 15.0629C13.6042 14.9882 13.7808 14.912 13.9456 14.8342L14.487 14.5811C15.2103 14.2544 15.768 14.1144 16.475 14.8214C17.4923 15.8387 17.2286 16.7779 15.9885 17.6331C14.7531 18.4831 13.259 18.8737 11.7656 18.7369C10.2723 18.6 8.87399 17.9445 7.81364 16.8841L4.10131 13.1717C3.49891 12.5774 3.02004 11.8697 2.69226 11.0895C2.36448 10.3093 2.19428 9.47192 2.19144 8.62566C2.18861 7.7794 2.3532 6.94094 2.67574 6.15855C2.99828 5.37616 3.4724 4.6653 4.0708 4.0669C4.66921 3.4685 5.38007 2.99438 6.16245 2.67183C6.94484 2.34929 7.78331 2.1847 8.62957 2.18754C9.47583 2.19037 10.3132 2.36058 11.0934 2.68835C11.8736 3.01613 12.5813 3.49617 13.1756 4.09857Z"
                fill="#FFA033"
              />
            </svg>
          </div>
        </div>

        {/* 标题 */}
        <div className={styles.title}>{t("You're About To Leave The Site")}</div>

        {/* 说明文本 */}
        <div className={styles.description}>{t('Source Website Click')}</div>

        {/* URL 显示框 */}
        <div className={styles.urlBox}>
          <div className={styles.urlText}>{targetUrl}</div>
        </div>

        {/* 底部提示文本 */}
        <div className={styles.footerText}>{t('Please review their terms and privacy policy before proceeding.')}</div>

        {/* 按钮组 */}
        <div className={styles.btnGroup}>
          <button className={styles.cancelBtn} onClick={handleCancel}>
            {t('Cancel')}
          </button>
          <button className={styles.continueBtn} onClick={handleContinue}>
            {t('Continue')}
          </button>
        </div>
      </div>
    </OurModal>
  );
};

export default LeaveWebsiteComponent;
